import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

class RelativeTime extends PureComponent {
	componentDidMount() {
		const { interval } = this.props

		this.update()

		this.interval = setInterval(this.update, interval)
	}

	componentWillUnmount() {
		clearInterval(this.interval)
	}

	update = () => {
		this.forceUpdate()
	}

	render() {
		const { time } = this.props

		return <>{moment().to(time)}</>
	}
}

RelativeTime.propTypes = {
	time: PropTypes.string.isRequired,
	interval: PropTypes.number,
}

RelativeTime.defaultProps = {
	interval: 30000,
}

export default RelativeTime
